import { Component, effect, input } from "@angular/core";
import { AppState } from "src/app/ngrx/reducers";
import { Store } from "@ngrx/store";
import { InstructionActions } from "src/app/ngrx/actions";
import { InstructionType } from "src/app/models/instruction/instruction";
import { InstructionsComponent } from "../instructions/instructions.component";

@Component({
  selector: "app-instruction-page",
  templateUrl: "./instruction-page.component.html",
  styles: ``,
  imports: [InstructionsComponent],
})
export class InstructionPageComponent {
  instructionType = input<InstructionType>();

  constructor(private readonly store: Store<AppState>) {
    effect(() => {
      const instructionType = this.instructionType();

      if (instructionType !== undefined) {
        this.store.dispatch(
          InstructionActions.loadInstructions({
            instructionType: instructionType,
          }),
        );
      }
    });
  }
}
